import { BreakpointObserver } from "@angular/cdk/layout";
import { CommonModule } from "@angular/common";
import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule, MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule, MatPaginator } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSortModule, MatSort } from "@angular/material/sort";
import { MatTableModule, MatTableDataSource } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { ButtonActionComponent } from "@component/button-action/button-action.component";
import { ButtonFilterTableClearComponent } from "@component/button-filter-table-clear/button-filter-table-clear.component";
import { ButtonFilterTableComponent } from "@component/button-filter-table/button-filter-table.component";
import { ButtonNewComponent } from "@component/button-new/button-new.component";
import { SinDatosParaMostrarComponent } from "@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component";
import { StatusBadgeComponent } from "@component/status-badge/status-badge.component";
import { AppRolesDirective } from "@directives/appRoles/app-roles.directive";
import { DialogParams } from "@interfaces/dialogParam.interface.model";
import { AccionesDialog, Roles } from "@models/base/identificadores.model";
import { CalendarioJudicialFilter } from "@models/calendarioJudicial/calendarioJudicialFilter.model";
import { CalendarioJudicialService } from "@services/calendarioJudicial/calendarioJudicial.service";
import { PersonaService } from "@services/persona/persona.service";
import { RolEmpresaService } from "@services/rolEmpresa/rolEmpresa.service";
import { SnackBarService } from "@services/snackBar/snack-bar-service.service";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { DialogFormCalendarioJudicialComponent } from "../dialog-form-calendario-judicial/dialog-form-calendario-judicial.component";
import { CalendarioJudicialDto } from "@models/calendarioJudicial/calendarioJudicialDto.model";
import { JuzgadoService } from "@services/juzgado/juzgado.service";
import { JuzgadoDto } from "@models/juzgado/juzgadoDto.model";
import { FueroService } from "@services/fuero/fuero.service";
import { BaseDto } from "@models/base/baseDto.model";
import { JuridiccionService } from "@services/juridiccion/juridiccion.service";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

@Component({
  standalone: true,
  imports: [CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgxSpinnerModule,
    AppRolesDirective,
    SinDatosParaMostrarComponent,
    MatCheckboxModule,
    MatSlideToggleModule,
    ButtonNewComponent,
    StatusBadgeComponent,
    ButtonActionComponent,
    MatTooltipModule,
    ButtonFilterTableClearComponent,
    ButtonFilterTableComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatTableModule,
    MatSelectModule,
    MatButtonToggleModule,
    NgxSpinnerModule],
  selector: 'app-calendario-judicial',
  templateUrl: './list-calendario-judicial.component.html',
  styleUrl: './list-calendario-judicial.component.css',
})
export class ListCalendarioJudicialComponent implements OnInit, AfterViewInit {
  accionesDialog = AccionesDialog;
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  data = false
  displayedColumns: string[] = [];
  public calendarioJudicial: CalendarioJudicialDto[] = [];
  dataSource = new MatTableDataSource<CalendarioJudicialDto>();
  isLoading: boolean = true;
  errorMessage: string = "";
  @ViewChild(MatSort) sort!: MatSort

  isChecked: boolean = false;
  checkedFiltroAvanzado: boolean = false
  roles: any;
  juzgados!: JuzgadoDto[];
  fueros!: BaseDto[];
  jurisdicciones!: BaseDto[];

  constructor(
    private calendarioJudicialService: CalendarioJudicialService,
    private juzgadoService: JuzgadoService,
    private juridiccionService: JuridiccionService,
    private fueroService: FueroService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private dialog: MatDialog,
    private rolEmpresaService: RolEmpresaService
  ) {

    this.formFilter = this.formBuilder.group({
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      FechaModificacionDesde: [null],
      FechaModificacionHasta: [null],
      FechaDesde: [null],
      FechaHasta: [null],
      EsHabil: [null],
      EsFeriado: [null],
      EsFeriaJudicial: [null],
      Motivo: [null],
      IdsJurisdiccion: [null],
      IdsFuero: [null],
      IdsJuzgado: [null],
      HorarioDesde: [null],  // formato HH:mm si lo vas a mostrar como string
      HorarioHasta: [null]
    });

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["fecha", "motivo", "accion"] :
        ["fecha", "motivo", "esHabil", "esFeriado", "esFeriaJudicial", "jurisdiccion", "fuero", "juzgado", "accion"];
    });


  }

  private paginator!: MatPaginator;

  ;

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  ngOnInit(): void {
    this.iniciaFiltroTabla()
  }

  iniciaFiltroTabla() {
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const search = filter.trim().toLowerCase();
      return (
        data.calendarioJudicial?.fecha?.toLowerCase().includes(search) ||
        data.calendarioJudicial?.motivo?.toLowerCase().includes(search) ||
        data.calendarioJudicial?.jurisdiccion?.descripcion.toLowerCase().includes(search) ||
        data.calendarioJudicial?.fuero?.descripcion.toLowerCase().includes(search) ||
        data.calendarioJudicial?.juzgado?.descripcion.toLowerCase().includes(search)
      );
    }
  }

  guardarFiltro() {
    const filtro: CalendarioJudicialFilter = this.formFilter.value;
    localStorage.setItem('filtroCalendarioJudicialGuardado', JSON.stringify(filtro));
  }

  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroCalendarioJudicialGuardado');
  }

  filtrosAvanzados(event: any) {
    if (event.checked == true) {
      this.checkedFiltroAvanzado = true
      if (!this.fueros)
        this.getAllFueros()
      if (!this.juzgados)
        this.getAllJuzgados()
      if (!this.jurisdicciones)
        this.getAllJurisdicciones()
    }
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro(filtro: CalendarioJudicialFilter = this.formFilter.value) {
    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }

  applyFilter(event: any) {
    if (event && event.target && event.target instanceof HTMLInputElement) {
      let filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }
  getAllByFilter(filtro: CalendarioJudicialFilter) {
    this.spinner.show('spCalendarioJudicial')
    this.calendarioJudicialService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spCalendarioJudicial')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spCalendarioJudicial')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllJuzgados() {
    this.spinner.show("spBusquedaJuzgados")
    this.juzgadoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaJuzgados")
          this.juzgados = data
        },
        error => {
          this.spinner.hide("spBusquedaJuzgados")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllJurisdicciones() {
    this.spinner.show("spBusquedaJurisdicciones")
    this.juridiccionService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaJurisdicciones")
          this.jurisdicciones = data
        },
        error => {
          this.spinner.hide("spBusquedaJurisdicciones")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllFueros() {
    this.spinner.show("spBusquedaFueros")
    this.fueroService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaFueros")
          this.fueros = data
        },
        error => {
          this.spinner.hide("spBusquedaFueros")
          this.snackBar.showError(error, "Error");
        })
  }

  cambiarRangoFechas(valor: string): void {
    const hoy = new Date();
    let fechaDesde: Date | null = null;
    let fechaHasta: Date | null = null;

    switch (valor) {
      case 'hoy':
        fechaDesde = new Date(hoy);
        fechaDesde.setHours(0, 0, 0, 0); // inicio del día
        fechaHasta = new Date(hoy);
        fechaHasta.setHours(23, 59, 59, 999); // fin del día
        break;

      case 'semana':
        fechaDesde = new Date(hoy);
        fechaDesde.setDate(hoy.getDate() - 7);
        fechaDesde.setHours(0, 0, 0, 0);

        fechaHasta = new Date(hoy);
        fechaHasta.setHours(23, 59, 59, 999);
        break;

      case 'mes':
        fechaDesde = new Date(hoy);
        fechaDesde.setMonth(hoy.getMonth() - 1);
        fechaDesde.setHours(0, 0, 0, 0);

        fechaHasta = new Date(hoy);
        fechaHasta.setHours(23, 59, 59, 999);
        break;

      case 'anio':
        fechaDesde = new Date(hoy);
        fechaDesde.setFullYear(hoy.getFullYear() - 1);
        fechaDesde.setHours(0, 0, 0, 0);

        fechaHasta = new Date(hoy);
        fechaHasta.setHours(23, 59, 59, 999);
        break;
    }

    this.formFilter.patchValue({
      FechaDesde: fechaDesde,
      FechaHasta: fechaHasta
    });
    this.aplicarFiltro();
  }


  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "70%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormCalendarioJudicialComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = (data: any, filter: string) => {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.userName) !== -1
        && data.estado.toString().toLowerCase().indexOf(searchTerms.activo) !== -1
    }
    return filterFunction;
  }

  sortingDataAccessor() {
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'fecha':
          return item.calendarioJudicial?.fecha?.toLowerCase() || '';
        case 'motivo':
          return item.calendarioJudicial?.motivo?.toLowerCase() || '';
        case 'jurisdiccion':
          return item.calendarioJudicial?.jurisdiccion?.descripcion?.toLowerCase() || '';
        case 'fuero':
          return item.calendarioJudicial?.fuero?.descripcion?.toLowerCase() || '';
        case 'juzgado':
          return item.calendarioJudicial?.juzgado?.descripcion?.toLowerCase() || '';
        case 'esFeriado':
          return item.calendarioJudicial?.esFeriado ? 1 : 0;
        case 'esFeriaJudicial':
          return item.calendarioJudicial?.esFeriaJudicial ? 1 : 0;
        case 'esHabil':
          return item.calendarioJudicial?.esHabil ? 1 : 0;
        default:
          return item[property];
      }
    };
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.sortingDataAccessor()
  }
}
